import React, { useEffect, useState } from "react";
import api from "@/api/client";

export default function AuditLog() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/audit").then(r => setItems(r.data)).catch(() => {}); }, []);
    return (
        <div data-testid="audit-page" className="space-y-6">
            <div>
                <div className="text-[11px] uppercase tracking-wider text-stone-500 mb-1">Admin</div>
                <h1 className="text-3xl font-heading font-semibold text-stone-900">Audit log</h1>
                <p className="text-sm text-stone-500 mt-1">Click-level record of every action. Cannot be edited or deleted.</p>
            </div>
            <div className="bg-white border border-stone-200 rounded-xl overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="bg-stone-50 text-[11px] uppercase tracking-wider text-stone-500">
                            <th className="text-left py-3 px-4">Timestamp</th>
                            <th className="text-left py-3 px-4">User</th>
                            <th className="text-left py-3 px-4">Role</th>
                            <th className="text-left py-3 px-4">Department</th>
                            <th className="text-left py-3 px-4">Action</th>
                            <th className="text-left py-3 px-4">Entity</th>
                            <th className="text-left py-3 px-4">IP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(a => (
                            <tr key={a.id} className="border-t border-stone-100 hover:bg-stone-50">
                                <td className="py-2.5 px-4 text-xs font-mono text-stone-600">{a.timestamp?.replace("T", " ").slice(0, 19)}</td>
                                <td className="py-2.5 px-4">{a.user_name || a.user_email || "—"}</td>
                                <td className="py-2.5 px-4 text-xs capitalize">{a.role?.replace("_", " ") || "—"}</td>
                                <td className="py-2.5 px-4 text-xs">{a.department || "—"}</td>
                                <td className="py-2.5 px-4"><span className="text-xs px-2 py-0.5 rounded-md bg-amber-50 border border-amber-200 text-amber-800 font-mono">{a.action}</span></td>
                                <td className="py-2.5 px-4 text-xs text-stone-700"><div>{a.entity}</div><div className="font-mono text-[10px] text-stone-500">{a.entity_id}</div></td>
                                <td className="py-2.5 px-4 text-xs text-stone-500">{a.ip || "—"}</td>
                            </tr>
                        ))}
                        {items.length === 0 && <tr><td colSpan={7} className="py-10 text-center text-stone-500 text-sm">No audit entries yet.</td></tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
